<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>


<div class="mdc-layout-grid__inner" *ngIf="!loading && !exists">
	<div class="mdc-layout-grid__cell--span-12 center">
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<mat-icon class="large">search</mat-icon>
			</div>

			<div class="mdc-layout-grid__cell--span-12">
				<h2 id="n40">{{ locale.translations['ads']['ad']['n40'] }}</h2>
			</div>

			<div class="mdc-layout-grid__cell--span-12" style="padding-bottom: 24px">
				<a mat-flat-button color="primary" href="/" class="n18 no-underline">
					{{ locale.translations['404']['n18'] }}
				</a>
			</div>
		</div>
	</div>
</div>

<div class="mdc-layout-grid__inner mt-3" *ngIf="!loading">
	<!--Ad detail section-->
	<ng-container *ngIf="exists">
		<!-- breadcrumbs -->
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
			<ul class="breadcrumbs" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
				<!-- home -->
				<li class="n107" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
					<a href="/" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
						{{ locale.translations['header']['n107'] }}
					</a>
				</li>

				<!-- category -->
				<li
					*ngIf="
						ad['data']['catID'] !== '' &&
						ad['data']['catID'] !== null &&
						ad['data']['catID'] !== undefined &&
						ad['data']['category'] !== '' &&
						ad['data']['category'] !== null &&
						ad['data']['category'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a [routerLink]="['/c/' + ad['data']['catID']]" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
						{{ ad['data']['category'] }}
					</a>
				</li>

				<!-- subcategory -->
				<li
					*ngIf="
						ad['data']['subCatID'] !== '' &&
						ad['data']['subCatID'] !== null &&
						ad['data']['subCatID'] !== undefined &&
						ad['data']['subCategory'] !== '' &&
						ad['data']['subCategory'] !== null &&
						ad['data']['subCategory'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a
						[routerLink]="['/c/' + ad['data']['catID']]"
						[queryParams]="{ subCatID: ad['data']['subCatID'] }"
						[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
					>
						{{ ad['data']['subCategory'] }}
					</a>
				</li>

				<!-- motor make -->
				<li
					*ngIf="
						ad['data']['motorMakeID'] !== '' &&
						ad['data']['motorMakeID'] !== null &&
						ad['data']['motorMakeID'] !== undefined &&
						ad['data']['motorMake'] !== '' &&
						ad['data']['motorMake'] !== null &&
						ad['data']['motorMake'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a
						[routerLink]="['/c/' + ad['data']['catID']]"
						[queryParams]="{ subCatID: ad['data']['subCatID'], makeID: ad['data']['motorMakeID'] }"
						[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
					>
						{{ ad['data']['motorMake'] }}
					</a>
				</li>

				<!-- electronics brand -->

				<li
					*ngIf="
						ad['data']['electronicBrandID'] !== '' &&
						ad['data']['electronicBrandID'] !== null &&
						ad['data']['electronicBrandID'] !== undefined &&
						ad['data']['electronicBrand'] !== '' &&
						ad['data']['electronicBrand'] !== null &&
						ad['data']['electronicBrand'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a
						[routerLink]="['/c/' + ad['data']['catID']]"
						[queryParams]="{ subCatID: ad['data']['subCatID'], makeID: ad['data']['electronicBrandID'] }"
						[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
					>
						{{ ad['data']['electronicBrand'] }}
					</a>
				</li>

				<!-- electronic model -->
				<li
					*ngIf="
						ad['data']['electronicModelID'] !== '' &&
						ad['data']['electronicModelID'] !== null &&
						ad['data']['electronicModelID'] !== undefined &&
						ad['data']['electronicModel'] !== '' &&
						ad['data']['electronicModel'] !== null &&
						ad['data']['electronicModel'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a
						[routerLink]="['/c/' + ad['data']['catID']]"
						[queryParams]="{
							subCatID: ad['data']['subCatID'],
							makeID: ad['data']['electronicBrandID'],
							modelID: ad['data']['electronicModelID']
						}"
						[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
					>
						{{ ad['data']['electronicModel'] }}
					</a>
				</li>

				<!-- motor model -->
				<li
					*ngIf="
						ad['data']['motorModelID'] !== '' &&
						ad['data']['motorModelID'] !== null &&
						ad['data']['motorModelID'] !== undefined &&
						ad['data']['motorModel'] !== '' &&
						ad['data']['motorModel'] !== null &&
						ad['data']['motorModel'] !== undefined
					"
					[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
				>
					&nbsp;&gt;&nbsp;
					<a
						[routerLink]="['/c/' + ad['data']['catID']]"
						[queryParams]="{
							subCatID: ad['data']['subCatID'],
							makeID: ad['data']['motorMakeID'],
							modelID: ad['data']['motorModelID']
						}"
						[dir]="locale.lang === 'en' ? 'ltr' : 'rtl'"
					>
						{{ ad['data']['motorModel'] }}
					</a>
				</li>
			</ul>
		</div>

		<!-- gallery -->
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone" style="position: relative">
			<div *ngIf="viewport.type === 'mobile'" [ngClass]="{ reverse: locale.lang != 'en' }">
				<div class="fav-btn">
					<button
						mat-icon-button
						(click)="onWatch($event)"
						[color]="ad['data']['watching'] === '1' ? apprColor() : ''"
						[ngStyle]="{ opacity: ad['data']['watching'] === '1' ? '1' : '0.5' }"
					>
						<mat-icon class="mat-icon-rtl-mirror fg-white">favorite_border</mat-icon>
					</button>
				</div>
			</div>

			<div
				class="mb-2 mx-2"
				[ngClass]="{ 'button-container-rtl': locale.lang !== 'en', 'button-container': locale.lang === 'en' }"
				*ngIf="ad['data']['sold'] === '0'"
			>
				<button mat-button class="w-100 fg-white fs-11px" [disableRipple]="true" (click)="onFullscreen('0')">
					<mat-icon class="fs-14px mt-2">image</mat-icon>
					{{ locale.translations['n703'] }}
				</button>
			</div>

			<div
				*ngIf="(ad['seller']?.['id'] === user?.['userID']) &&
					(ad['data']['paymentPackage'] === '2' && ad['data']['paymentStatus'] === '0') ||
					(ad['data']['paymentPackage'] === '0' && ad['data']['premium'] === '1' && ad['data']['vip'] === '0')

				"
				class="payment-status"
			>
				{{ locale.translations['ads']['ad']['n225'] }}
			</div>

			<div
				*ngIf="ad['seller']?.['id'] === user?.['userID'] && ad['data']['paymentPackage'] === '3' && ad['data']['paymentStatus'] === '0' "
				class="payment-status"
			>
				{{ locale.translations['ads']['ad']['n659'] }}
			</div>

			<ngb-carousel
				#carousel="ngbCarousel"
				*ngIf="ad['images']"
				[ngClass]="{ 'no-indicators': ad['images'].length == 1 }"
				[dir]="locale.lang == 'en' ? 'ltr' : 'rtl'"
				[interval]="false"
			>
				<ng-template ngbSlide *ngFor="let image of ad['images']; let i = index" id="{{ i }}">
					<div class="slide-container" [ngClass]="{ desktop: viewport.type === 'desktop' }" (click)="onFullscreen(i)">
						<img [src]="image['name']" />
					</div>
				</ng-template>
			</ngb-carousel>
		</div>
		<!-- key info -->
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
			<div class="mdc-layout-grid__inner">
				<ng-container
					*ngIf="ad['data']['vip'] === '1' || ad['data']['vipPlus'] === '1' || ad['data']['sold'] === '1' || ad['data']['paymentStatus'] === '0'"
				>
					<div class="mdc-layout-grid__cell--span-12 d-flex flex-row justify-content-start align-items-center sold-vip">
						<ng-container *ngIf="ad['data']['sold'] === '1'">
							<h4 class="sold" id="n111">{{ locale.translations['ads']['ad']['n111'] }}</h4>
							&nbsp;
						</ng-container>

						<!-- vipPlus -->
						<ng-container *ngIf="ad['data']['vipPlus'] === '1'">
							<a [href]="'/' + locale.getLocale() + '/vip-plus?adLink=' + ad['data']['adLink']">
								<h4 class="vip" dir="ltr">{{ locale.translations['n729'] }}</h4>
							</a>

							<a class="learn-more-label" [href]="'/' + locale.getLocale() + '/vip-plus?adLink=' + ad['data']['adLink']">
								<span class="vip-label" dir="ltr">{{ locale.translations['n702'] }}</span>
							</a>
						</ng-container>

						<!-- vip -->
						<ng-container *ngIf="ad['data']['vip'] === '1'">
							<a [href]="'/' + locale.getLocale() + '/vip'">
								<h4 class="vip">{{ locale.translations['ads']['ad']['n118'] }}</h4>
							</a>

							<a class="learn-more-label" [href]="'/' + locale.getLocale() + '/vip'">
								<span class="vip-label">{{ locale.translations['vip']['n181'] }}</span>
							</a>
						</ng-container>
					</div>
				</ng-container>

				<header appObserveElement class="mdc-layout-grid__cell--span-6" #adHeader="intersection" (isIntersecting)="onAdHeaderIntersect($event)">
					<h2>{{ ad['data']['title'] }}</h2>
					<h2 #price>&#36; {{ numbers.format(ad['data']['price']) }}</h2>
				</header>

				<ng-container
					*ngIf="ad['data']['sold'] !== '1'"
					[ngTemplateOutlet]="callSection"
					[ngTemplateOutletContext]="{ $implicit: { adHeader } }"
				></ng-container>
			</div>
		</div>

		<!-- motor details -->
		<div
			class="mdc-layout-grid__cell--span-12"
			*ngIf="
				ad['data']['catID'] === '15' &&
				ad['data']['subCatID'] === '291' &&
				(ad['data']['motorMake'] || ad['data']['motorModel'] || ad['data']['motorYear'] || ad['data']['motorColor'])
			"
		>
			<div class="mdc-layout-grid__inner">
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['motorMake']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">security</mat-icon>

						<span>{{ ad['data']['motorMake'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['motorModel']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">directions_car</mat-icon>

						<span>{{ ad['data']['motorModel'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['motorYear']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">today</mat-icon>

						<span>{{ ad['data']['motorYear'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['motorColor']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['motorColor'] }}</span>
					</span>
				</div>
			</div>
		</div>

		<!-- electronic details -->
		<div
			class="mdc-layout-grid__cell--span-12"
			*ngIf="
				ad['data']['catID'] === '16' &&
				(ad['data']['subCatID'] === '302' ||
					ad['data']['subCatID'] === '303' ||
					ad['data']['subCatID'] === '304' ||
					ad['data']['subCatID'] === '305' ||
					ad['data']['subCatID'] === '306' ||
					ad['data']['subCatID'] === '307' ||
					ad['data']['subCatID'] === '308' ||
					ad['data']['subCatID'] === '309' ||
					ad['data']['subCatID'] === '310' ||
					ad['data']['subCatID'] === '311' ||
					ad['data']['subCatID'] === '312' ||
					ad['data']['subCatID'] === '313') &&
				(ad['data']['electronicBrand'] ||
					ad['data']['electronicModel'] ||
					ad['data']['electronicColor'] ||
					ad['data']['electronicStorage'] ||
					ad['data']['electronicMemory'] ||
					ad['data']['electronicProcessor'] ||
					ad['data']['electronicGraphic'] ||
					ad['data']['electronicNetwork'])
			"
		>
			<div class="mdc-layout-grid__inner">
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicBrand']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">security</mat-icon>

						<span>{{ ad['data']['electronicBrand'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicModel']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">layers</mat-icon>

						<span>{{ ad['data']['electronicModel'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicColor']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicColor'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicStorage']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicStorage'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicMemory']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicMemory'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicProcessor']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicProcessor'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicGraphics']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicGraphics'] }}</span>
					</span>
				</div>

				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
					*ngIf="ad['data']['electronicNetwork']"
				>
					<span class="detail">
						<mat-icon class="mat-icon-rtl-mirror">color_lens</mat-icon>

						<span>{{ ad['data']['electronicNetwork'] }}</span>
					</span>
				</div>
			</div>
		</div>

		<!-- description -->
		<div class="mdc-layout-grid__cell--span-12">
			<div class="mdc-layout-grid__inner">
				<div
					class="mdc-layout-grid__cell--span-12"
					*ngIf="
						ad['data']['catID'] === '15' &&
						ad['data']['subCatID'] === '291' &&
						(ad['data']['motorMake'] || ad['data']['motorModel'] || ad['data']['motorYear'] || ad['data']['motorColor'])
					"
				>
					<mat-divider></mat-divider>
				</div>

				<div
					class="mdc-layout-grid__cell--span-12 description"
					appReadMore
					[description]="ad['data']?.description"
					[descriptionUnmasking]="ad['data']['paymentHold'] === 0 || ad['data']['isActive'] === '1' ? true : false"
					(phoneNumberClicked)="handlePhoneNumberClicked($event)"
				></div>
			</div>
		</div>

		<div class="mdc-layout-grid__cell--span-12">
			<mat-divider></mat-divider>
		</div>

		<div class="mdc-layout-grid__cell--span-12">
			<p class="detail">
				<mat-icon>place</mat-icon>

				<span>{{ ad['data']['location'] }}</span>
			</p>

			<p class="detail" *ngIf="(ad['data']['vipPlus'] === '1' && showCreatedAtDate) || ad['data']['vipPlus'] === '0'">
				<mat-icon>watch_later</mat-icon>

				<span>{{ time.fromNow(ad['data']['createdDate']) }}</span>
			</p>

			<p class="detail n35">
				<mat-icon>camera</mat-icon>

				<span *ngIf="ad['data']['vip'] === '1' || ad['data']['vipPlus'] === '1'">
					{{ ad['data']['vipViews'] }} {{ locale.translations['ads']['ad']['n35'] }}
				</span>

				<span *ngIf="ad['data']['vip'] !== '1' && ad['data']['vipPlus'] !== '1'">
					{{ ad['data']['views'] }} {{ locale.translations['ads']['ad']['n35'] }}
				</span>
			</p>

			<p class="detail" *ngIf="ad['data']['watchers'] !== '0'">
				<mat-icon>favorite</mat-icon>

				<span>{{ ad['data']['watchers'] }}</span>
			</p>

			<p class="detail">
				<i class="fas fa-hashtag"></i>

				<span>{{ ad['data']['adID'] }}</span>

				<img class="clipboard" (click)="onCopyAdIDToClipboard()" [src]="'assets/favicon/download-icon.svg' | s3Image" alt="download" />
			</p>
		</div>

		<div class="mdc-layout-grid__cell--span-12">
			<mat-divider></mat-divider>
		</div>

		<div class="mdc-layout-grid__cell--span-12" *ngIf="ad['seller']['type'] === '0'">
			<p class="detail">
				<mat-icon>account_circle</mat-icon>

				<span>{{ ad['seller']['name'] | titlecase }}</span>
			</p>

			<div *ngIf="user">
				<p
					*ngIf="ad['data']['userID'] === user['userID'] && (ad['data']['vip'] === '1' || ad['data']['premium'] === '1')"
					mat-button
					class="detail analytics"
					[routerLink]="['/ads-analytics']"
					[queryParams]="{ adID: ad['data']['adID'] }"
				>
					<mat-icon>analytics</mat-icon>

					<span>{{ locale.translations['ads']['ad']['n307'] }}</span>
				</p>
			</div>

			<mat-divider *ngIf="ad['data']['sold'] !== '1'"></mat-divider>
		</div>

		<!--dealer profile section-->
		<div class="mdc-layout-grid__cell--span-12" *ngIf="ad['seller']['type'] === '1'">
			<p>{{ locale.translations['dealer']['n382'] }}</p>

			<div class="row">
				<div class="col-12 col-md-4">
					<p class="detail">
						<mat-icon class="icon-color">business</mat-icon>

						<span>{{ ad['seller']['name'] }}</span>
					</p>
				</div>

				<ng-container *ngIf="ad['data']['sold'] !== '1'">
					<div class="col-12 col-md-4">
						<p class="detail">
							<mat-icon
								class="icon-color cursor-pointer mat-icon-rtl-mirror"
								[matMenuTriggerFor]="viewport.type === 'mobile' || ad['seller']['contactTypeWhatsapp'] === '1' ? menu1 : null"
							>
								call
							</mat-icon>

							<span class="cursor-pointer" [matMenuTriggerFor]="menu1">{{ ad['seller']['phone'] }}</span>
						</p>

						<mat-menu #menu1="matMenu">
							<ng-template matMenuContent>
								<button mat-menu-item *ngIf="viewport.type === 'mobile'" (click)="OnContact()">
									<img class="call_icon" [src]="'/assets/favicon/call.png' | s3Image" />
									{{ locale.translations['logup']['login']['n229'] }}
								</button>

								<ng-container>
									<button mat-menu-item *ngIf="ad['seller']['contactTypeWhatsapp'] === '1'" (click)="onWhatsappCall()">
										<img class="call_icon" [src]="'/assets/favicon/whatsapp.png' | s3Image" />
										{{ locale.translations['ads']['ad']['n297'] }}
									</button>
								</ng-container>
							</ng-template>
						</mat-menu>
					</div>
				</ng-container>

				<div class="col-12 col-md-4">
					<p class="detail">
						<mat-icon class="icon-color">place</mat-icon>

						<span>{{ ad['seller']['city'] || 'N/A' }}</span>
					</p>
				</div>
			</div>

			<div class="col-12 col-md-4 mt-3" style="padding: 0">
				<button [routerLink]="['/dealer/' + ad['seller']['id'] + '/ads']" mat-button class="dealer-action dealer-btn-border" mat-flat-button>
					{{ locale.translations['dealer']['n383'] }}
				</button>
			</div>

			<mat-divider style="margin-top: 24px" *ngIf="ad['data']['sold'] !== '1'"></mat-divider>
		</div>
	</ng-container>

	<!-- related ads -->

	<ng-container>
		<div class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone mx-3">
			<app-google-ad [type]="googleAd.BANNER"></app-google-ad>
		</div>

		<ng-container *ngIf="ad['related']; else recentads">
			<div
				*ngIf="ad['related'].length"
				class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
				id="n47"
			>
				<h4>{{ locale.translations['ads']['ad']['n94'] }}</h4>
			</div>

			<!--related ads section start-->
			<ng-container *ngFor="let ad of ad['related']; let i = index">
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone box"
					*ngIf="ad['vipPlus'] === '0'"
				>
					<!-- AD item -->
					<app-ad-item [ad]="ad"></app-ad-item>
				</div>
				<div
					class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone"
					*ngIf="ad['vipPlus'] === '1'"
				>
					<!-- AD item -->
					<app-ad-item-v2 [ad]="ad"></app-ad-item-v2>
				</div>
			</ng-container>
		</ng-container>
		<!--related ads section end-->

		<!--Recent section-->
		<ng-template #recentads>
			<div
				*ngIf="ad['recent'].length"
				class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
				id="n47"
			>
				<h4>{{ locale.translations['home']['n48'] }}</h4>
			</div>

			<ng-container *ngFor="let ad of ad['recent']; let i = index">
				<div
					class="mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone box"
					*ngIf="ad['vipPlus'] === '0'"
				>
					<!-- AD item -->
					<app-ad-item [ad]="ad"></app-ad-item>
				</div>

				<div
					class="mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone"
					*ngIf="ad['vipPlus'] === '1'"
				>
					<!-- AD item -->
					<app-ad-item-v2 [ad]="ad"></app-ad-item-v2>
				</div>
			</ng-container>
		</ng-template>
		<!--end of Recent section-->
	</ng-container>
</div>

<div *ngIf="!loading" [ngClass]="viewport.type === 'desktop' ? 'mt-3' : 'mt-2'" class="mb-2">
	<app-google-ad [type]="googleAd.MULTIPLEX"></app-google-ad>
</div>

<!-- Mobile button call header -->
<ng-template #mobileBtnCallHeader let-data>
	<div class="row mx-0 mb-2 justify-content-between align-items-center">
		<div class="col-auto p-0">
			<span class="text-body-14px-regular">{{ ad['data']['title'] }}</span>
		</div>
		<div class="col-auto p-0">
			<span class="text-body-14px-regular">&#36; {{ numbers.format(ad['data']['price']) }}</span>
		</div>
	</div>
</ng-template>
<!-- end - Mobile button call header -->

<!-- Call section -->
<ng-template #callSection let-data>
	<div
		class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-6-phone"
		[class.call-container]="viewport.type === 'mobile' || !data.adHeader._isIntersecting"
		[class.call-container--top]="viewport.type === 'desktop' && !data.adHeader._isIntersecting"
	>
		<!-- Button favorite -->
		<div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
			<!-- Mobile button call header -->
			<ng-container *ngIf="viewport.type !== 'desktop' && !data.adHeader._isIntersecting" [ngTemplateOutlet]="mobileBtnCallHeader"></ng-container>

			<div class="row mx-auto align-items-center ad-header">
				<div class="col-6 p-0" *ngIf="viewport.type === 'desktop' && !data.adHeader._isIntersecting">
					<header class="d-flex align-items-center gx-16px">
						<h2 class="m-0">{{ ad['data']['title'] }}</h2>
						<mat-divider vertical class="header-divider"></mat-divider>
						<h2 class="m-0">&#36; {{ numbers.format(ad['data']['price']) }}</h2>
					</header>
				</div>

				<div class="col p-0">
					<div class="d-flex justify-content-between align-items-center gap-2">
						<button
							*ngIf="viewport.type !== 'mobile'"
							class="action mobile n37"
							mat-button
							(click)="onWatch($event)"
							[color]="ad['data']['watching'] === '1' ? apprColor() : ''"
						>
							<mat-icon class="mat-icon-rtl-mirror">favorite</mat-icon>

							<span>
								{{
									ad['data']['watching'] === '1'
										? locale.translations['ads']['ad']['n37']['n37-1']
										: locale.translations['ads']['ad']['n37']['n37-2']
								}}
							</span>
						</button>

						<!--  call button -->
						<ng-container *ngIf="ad['data']['paymentHold'] === 0 && ad['data']['isExpired'] === 0 && ad['data']['isActive'] === 1">
							<button
								mat-button
								class="btn-call action mobile"
								mat-flat-button
								(click)="onClickingPhoneNumber()"
								[ngClass]="{ 'reverse-animation': locale.lang !== 'en' }"
							>
								<mat-icon class="mat-icon-rtl-mirror">call</mat-icon>
								<span [textContent]="showFullPhoneNumber ? ad['data']['phone'] : ad['data']['phone'].slice(0, -4) + 'XXXX'"></span>
							</button>

							<!-- Whatsapp -->
							<div class="ad-item-chats" *ngIf="ad['seller']['contactTypeWhatsapp'] === '1'">
								<app-button class="icon" svgIcon="whatsapp-2" [btnType]="buttonType.ICON" (clicked)="onWhatsappCall()"></app-button>
							</div>
						</ng-container>

						<!-- notify seller button  -->

						<button
							*ngIf="ad['data']['paymentHold'] === 1 && ad['data']['isExpired'] === 0 && ad['data']['isActive'] === 1"
							class="btn-call action mobile"
							[ngClass]="{ actions: locale.lang === 'ku' }"
							mat-flat-button
							(click)="notifySeller()"
						>
							<img [src]="'assets/icons/bell-icon.svg' | s3Image" alt="notify" class="mx-2" />
							<span class="notify-span">{{ locale.translations['ads']['ad']['n661'] }}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ng-container *ngIf="isMe">
		<div class="mdc-layout-grid__cell--span-12">
			<mat-divider></mat-divider>
		</div>

		<!-- REMOVED TEMPORARILY THE BANNER  -->
		<!-- <div
			class="mdc-layout-grid__cell--span-12 banner-main"
			*ngIf="
				ad['data']['vip'] !== '1' &&
				ad['data']['subCatID'] !== '0' &&
				ad['data']['isExpired'] === 0 &&
				ad['data']['paymentStatus'] === '1' &&
				ad['data']['isBasic'] === 0 &&
				ad['data']['missedCallsCount'] === 0 &&
				onAddComplete(ad['data'])
			"
		>
			<div class="row abs-row1 no-gutters d-flex flex-row justify-content-around align-items-center" *ngIf="locale.lang === 'en'">
				<div class="col-9 offset-3 col-sm-4 offset-sm-3 col-md-5 offset-md-3 col-lg-4 offset-lg-4">
					<h3 class="text-white f-size">{{ locale.translations['ads']['ad']['n463'] }}</h3>
				</div>

				<div class="col-9 offset-3 col-sm-4 offset-sm-1 col-md-3 offset-md-1 col-lg-3 offset-lg-1">
					<button class="action btn btn-sm bg-white boost" (click)="onOpenBoostAdDialog(ad)">
						<span style="vertical-align: top">
							<span *ngIf="getObjectLength(ad['data']['vipAd'])">{{ locale.translations['payment']['n621'] }}</span>

							<span *ngIf="ad['data']['vipAd']['remaningDaysForVIP'] < 0">{{ locale.translations['ads']['ad']['n455'] }}</span>
						</span>
					</button>
				</div>
			</div>

			<div class="row abs-row-other d-flex flex-row justify-content-around align-items-center" *ngIf="locale.lang === 'ar' || locale.lang === 'ku'">
				<div class="col-12 col-sm-6">
					<h3 class="text-white f-size">{{ locale.translations['ads']['ad']['n463'] }}</h3>
				</div>

				<div class="col-12 col-sm-6">
					<button class="action btn btn-sm bg-white boost" (click)="onOpenBoostAdDialog(ad)">
						<span style="vertical-align: top">
							<span *ngIf="getObjectLength(ad['data']['vipAd'])">{{ locale.translations['payment']['n621'] }}</span>

							<span *ngIf="ad['data']['vipAd']['remaningDaysForVIP'] < 0">{{ locale.translations['ads']['ad']['n455'] }}</span>
						</span>
					</button>
				</div>
			</div>

			<img src="/assets/images/vip/ad-detail-banner.png" style="max-width: 100%; min-height: 90px" [ngClass]="{ 'other-lang': locale.lang !== 'en' }" />
		</div> -->

		<div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
			<a class="action" mat-button [color]="apprColor()" [routerLink]="['/ad/' + ad['data']['adID'] + '/edit']">
				<mat-icon>create</mat-icon>

				<span>{{ locale.translations['user']['user-ads']['n84'] }}</span>
			</a>
		</div>

		<div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
			<button
				class="action"
				mat-button
				color="warn"
				type="button"
				(click)="onDelete(ad['data']['adID'])"
				[disabled]="ad['data']['paymentStatus'] === '0'"
			>
				<mat-icon>delete</mat-icon>

				<span>{{ locale.translations['user']['user-ads']['n85'] }}</span>
			</button>
		</div>
	</ng-container>
</ng-template>
<!-- end - Call section -->
